/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function VersionRepresentationFromJSON(json) {
    return VersionRepresentationFromJSONTyped(json, false);
}
export function VersionRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        name: json['name'],
        hexColor: json['hexColor'],
        order: json['order'],
        active: json['active'],
        versionTagId: json['versionTagId'],
        baselineTagId: json['baselineTagId'],
    };
}
export function VersionRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        name: value.name,
        hexColor: value.hexColor,
        order: value.order,
        active: value.active,
        versionTagId: value.versionTagId,
        baselineTagId: value.baselineTagId,
    };
}
